"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _conditionalRendering = require("./conditionalRendering");
var _checkConditions = require("./checkConditions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CustomSingleLineText = props => {
  var feedbackType = '',
    helperText = '',
    css = props.field.model.cssClass,
    shouldHide,
    showRequired = '';
  if (props.errors.length > 0) {
    feedbackType = 'invalid';
    css = css + ' is-invalid';
    props.errors.map((error, index) => /*#__PURE__*/_react.default.createElement("div", {
      className: "invalid-feedback",
      key: index
    }, helperText = error));
  }
  var field = props.field,
    fieldId = field.valueField.id,
    fieldName = field.valueField.name,
    state = _conditionalRendering.store.getState();
  var selectedValue = props.field.model.value;

  // setup for if the field is required
  if (field.model.required) {
    showRequired = "*";
  }
  var onChange = e => {
    var newValue = e.target.value;
    var fieldKey = field.model.conditionSettings.fieldKey;
    if (state !== undefined) {
      state.fieldValues[fieldKey] = newValue;
    }
    var valid = true,
      errorMessages = [];
    if (field.model.required && !newValue) {
      valid = false;
      errorMessages.push(field.model.title + ' is required');
    }
    props.onChange(fieldName, e.target.value, valid, errorMessages);
  };
  var conditionId = field.model.conditionSettings.fieldKey;
  if (state !== undefined) {
    if (state.conditions[conditionId] !== undefined) shouldHide = (0, _checkConditions.checkConditions)(state.fieldValues, state.conditions[conditionId]);
    var hideArray = state.hiddenFields;
    if (shouldHide) {
      if (hideArray.indexOf(fieldName) === -1) {
        hideArray.push(fieldName);
      }
    } else {
      if (hideArray.indexOf(fieldName) > -1) {
        hideArray = hideArray.filter(e => e !== fieldName);
      }
    }
    state.hiddenFields = hideArray;
  }
  if (shouldHide) {
    return null;
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.FormInput, {
      id: fieldId,
      name: fieldName,
      className: css,
      labelText: props.field.model.title !== '' ? props.field.model.title + showRequired : undefined,
      feedbackType: feedbackType !== '' ? feedbackType : undefined,
      maxLength: props.field.model.maxLength,
      placeholderText: props.field.model.placeholderText,
      helperText: helperText,
      onChange: onChange,
      defaultValue: selectedValue
    }));
  }
};
var _default = exports.default = CustomSingleLineText;